import permissions from './permission-list'

export default [
  {
    path: '/reviews',
    name: 'reviews',
    component: () => import('@/views/reviews/index.vue'),
    meta: {
      pageTitle: 'Daftar Review',
      resource: permissions.review,
      action: 'read',
      navActiveLink: 'reviews',
      breadcrumb: [
        {
          text: 'Daftar Review',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reviews/create',
    name: 'reviews-create',
    component: () => import('@/views/reviews/create.vue'),
    meta: {
      pageTitle: 'Buat Review',
      resource: permissions.review,
      action: 'manage',
      navActiveLink: 'reviews',
      breadcrumb: [
        {
          text: 'Review',
          active: false,
          to: { path: '/reviews' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reviews/:id/edit',
    name: 'reviews-edit',
    component: () => import('@/views/reviews/edit.vue'),
    meta: {
      pageTitle: 'Edit Review',
      resource: permissions.review,
      action: 'manage',
      navActiveLink: 'reviews',
      breadcrumb: [
        {
          text: 'Review',
          active: false,
          to: { path: '/reviews' },
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
